// src/components/admin/settings/EverydayWardrobeSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const EverydayWardrobeSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(data.settings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    setUploading(true);

    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/upload-wardrobe-image.php', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setSettings({ ...settings, wardrobe_image: data.image_url });
        toast.success('Wardrobe image uploaded!');
      } else {
        toast.error(data.message || 'Upload failed');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setUploading(false);
    }
  };

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Everyday wardrobe saved!');
      } else {
        toast.error('Failed to save');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading wardrobe settings...</div>;

  return (
    <div className="settings-page">
      <h2>Everyday Wardrobe Section</h2>
      <p className="section-description">Customize the "Upgrade Your Everyday Wardrobe" section</p>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Section Eyebrow</label>
          <input type="text" name="wardrobe_eyebrow" value={settings.wardrobe_eyebrow || 'The Edit'} onChange={handleChange} />
        </div>
        
        <div className="form-group">
          <label>Section Title</label>
          <input type="text" name="wardrobe_title" value={settings.wardrobe_title || 'Upgrade Your Everyday Wardrobe'} onChange={handleChange} />
        </div>
        
        <div className="form-group">
          <label>Section Description</label>
          <textarea name="wardrobe_description" value={settings.wardrobe_description || ''} onChange={handleChange} rows="3" />
        </div>
        
        <div className="form-group">
          <label>Button Text</label>
          <input type="text" name="wardrobe_button_text" value={settings.wardrobe_button_text || 'Start Shopping'} onChange={handleChange} />
        </div>
        
        <div className="form-group">
          <label>Wardrobe Image</label>
          {settings.wardrobe_image && (
            <div className="image-preview">
              <img src={`${settings.wardrobe_image}?t=${Date.now()}`} alt="Wardrobe" />
              <button type="button" className="remove-img-btn" onClick={() => setSettings({ ...settings, wardrobe_image: '' })}>Remove</button>
            </div>
          )}
          <input type="file" accept="image/*" onChange={handleImageUpload} disabled={uploading} />
        </div>
        
        <button type="submit" disabled={saving} className="save-btn">{saving ? 'Saving...' : 'Save Wardrobe'}</button>
      </form>
    </div>
  );
};

export default EverydayWardrobeSettings;